// Keeps the native Horizon announcement carousel accessible while retaining its rotating slide behavior.
const initMedivioAnnouncements = () => {
  document.querySelectorAll('[data-mv-announcement] announcement-bar-component').forEach((slider) => {
    if (slider.dataset.mvAnnouncementReady) return;
    slider.dataset.mvAnnouncementReady = 'true';

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const syncMotion = () => {
      if (reduced.matches) slider.pause?.();
      else if (!slider.matches(':focus-within') && !slider.matches(':hover')) slider.resume?.();
    };

    slider.addEventListener('focusin', () => slider.suspend?.());
    slider.addEventListener('focusout', () => {
      if (!reduced.matches && !slider.matches(':focus-within')) slider.resume?.();
    });
    reduced.addEventListener('change', syncMotion);
    customElements.whenDefined('announcement-bar-component').then(syncMotion);
  });
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initMedivioAnnouncements);
else initMedivioAnnouncements();
document.addEventListener('shopify:section:load', initMedivioAnnouncements);
